import React, { useEffect, useState, useContext } from "react";
import icon__close from "../../../asset/icon/close-icon.svg";
import * as MedicalApi from "../../../service/medicalApi";
import { HashLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";

import { CurrentUserContext } from "../../../App";

function ModalShowData({ titlename, onClose, onSend, detail, success }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  // console.log(detail)
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const postRequestPermission = async (uid) => {
    let res = "";
    setLoading(true);
    res = await MedicalApi.postRequestPermission(uid);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        }); // , 'กำลังพาท่านไปหน้าดูข้อมูล'
        // console.log(res)
        onClose();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className="fixed w-full h-full z-20 inset-0 flex justify-center items-center bg-[#0000008f]">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      <div className="w-[500px] h-[330px] sm:w-[370px] bg-[#FFFFFF] rounded-3xl">
        <div className="flex justify-end my-[5px]">
          <img
            onClick={() => {
              onClose();
            }}
            className="w-[30px] h-[30px] mr-[30px] hover:cursor-pointer"
            src={icon__close}
            alt=""
          />
        </div>
        <div className="mt-[20px] sm:mt-0 px-[30px] pb-[30px]">
          {success ? (
            <>
              <div className="text-center font-bold text-[#526F65]">
                {titlename}
              </div>
              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] my-[25px]"></div>
              <div className="grid justify-center text-center h-[130px]">
                <div className="text-[#A2B5BC] font-medium">
                  {detail?.pname + " " + detail?.fname + " " + detail?.lname}
                </div>
                <div className="text-[#A2B5BC] font-medium md:text-[13px]">
                  {detail.message}
                </div>
              </div>
              <div className="flex justify-center items-center gap-5 mt-1">
                {!detail?.is_allow ? (
                  <>
                    <button
                      onClick={() => {
                        postRequestPermission(detail?.uid);
                      }}
                      className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
                    >
                      ขออนุญาตผู้ป่วย
                    </button>

                    <button
                      onClick={() => {
                        onClose();
                      }}
                      className="button-theme-pg flex justify-center items-center w-48 h-10 border-[1px] border-solid border-[#B9DFC5] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
                    >
                      ยกเลิก
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        onClose();
                      }}
                      className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
                    >
                      ตกลง
                    </button>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="text-center font-bold text-[#526F65]">
                {titlename}
              </div>
              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] my-[25px]"></div>
              <div className="flex justify-center items-center h-[130px]">
                <div className="text-[#A2B5BC] font-medium">{detail}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalShowData;
